﻿import React, {FC} from 'react';
import {CollapsableCardBodyItemContainer} from "./CollapsableCardBodyItemContainer";
import {CollapsableCardLabel} from "./CollapsableCardLabel";
import {CollapsableCardValue} from "./CollapsableCardValue";
import {SlotType} from "../../../types/Slots";
import {useSlotOrDefault} from "../../../hooks/slots/useSlotOrDefault";

type CollapsableCardBodyItemProps = React.ComponentPropsWithoutRef<'div'> & {
  value: SlotType;
  label: SlotType;
  show?: boolean;
}

const CollapsableCardBodyItem: FC<CollapsableCardBodyItemProps> = ({ value, label, show = true, ...rest}) => {
  const Label = useSlotOrDefault(label, CollapsableCardLabel);
  const Value = useSlotOrDefault(value ?? '-', CollapsableCardValue);

  if (!show) return null;

  return <CollapsableCardBodyItemContainer {...rest}>
    {Label}
    {Value}
  </CollapsableCardBodyItemContainer>
}

export { CollapsableCardBodyItem };
